<div class="d-flex h-100 flex-column">
  <div class="toolbar-container">
    <mat-toolbar class="ios-top-padding">
      <div class="d-flex justify-content-between w-100 align-items-center">
        <!-- <b>IzyFisco</b> -->
        
        <img mat-card-image [src]="getLogoPath()"  alt="Logo" class="toolbar-logo" style="height: 20px;">

        <!-- izyfisco\src\ -->

        <!-- <mat-icon>
          notifications
          notifications_active
        </mat-icon> -->
      </div>
      <!-- <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon">
          <mat-icon>menu</mat-icon>
        </button> -->
      
      <span class="d-none d-md-inline">
        <!-- {{ (layoutService.organizationName$ | async) || "Organization" }} -->
        {{ organization_data?.name || " " }}
      </span>
      <span class="spacer"></span>

      <app-global-search class="toolbar-search-center"></app-global-search>

      <!-- class="d-md-none"  -->
      <!-- <button
        mat-icon-button
        aria-label="Main Menu"
        (click)="toggleMobileMenu()"
        class="d-block d-md-none"
      >
        <mat-icon>menu</mat-icon>
      </button> -->
      <button
        mat-icon-button
        aria-label="Main Menu"
        (click)="mobileMenu.toggle()"
        class="d-block d-md-none white"
      >
        <mat-icon>menu</mat-icon>
      </button>
      <!--
          <button mat-icon-button class="example-icon" aria-label="Example icon-button with share icon">
          <mat-icon>share</mat-icon>
        </button> -->
      <!-- "top" -->
    </mat-toolbar>
  </div>
  <div class="flex-grow-1 overflow-y-hidden">
    <mat-sidenav-container class="h-100">
      <mat-sidenav
        #sidenavBar
        mode="side"
        opened
        class="side-bar h-100 overflow-y-auto pt-3 d-none d-md-block"
      >
        <!-- d-none d-md-block -->
        <app-side-menu></app-side-menu>
      </mat-sidenav>
      <!-- mode="side" -->
      <!-- [opened]="mobileMenuIsOpen" -->
      <mat-sidenav
        #mobileMenu
        position="end"
        from="top"
        mode="over"
        class="mobile-menu h-100 overflow-y-auto pt-3 w-100 d-block d-md-none"
      >
        <!-- d-block d-md-none -->
        <app-side-menu (clickOnVoice)="clickOnVoice()"></app-side-menu>
      </mat-sidenav>
      <mat-sidenav-content class="h-100 overflow-y-auto">
        <div class="d-flex h-100 flex-column">
          <div class="main-container px-3 d-flex h-100 flex-column">
            <!-- <div class="row"> -->
            <!-- <div class="col"> -->
            <div class="h-100">
              <!-- <router-outlet></router-outlet> -->
              <ng-content></ng-content>
            </div>
            <!-- </div> -->
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>
